export class JobworkIdReq {
    jobworkId: number;
    vendorId: number;
}